import { ERequestStatus } from '../../services/requestStatus';
import { TOffers } from '../../types/offers';
import { IApplicationState } from '../../types/redux';

export const selectOffers = (state: IApplicationState): TOffers => state.offers.items;
export const selectOffersStatus = (state: IApplicationState): ERequestStatus => state.offers.status;
